import { render, staticRenderFns } from "./game-month-rounds2.vue?vue&type=template&id=0be8d2ad&scoped=true"
import script from "./game-month-rounds2.vue?vue&type=script&lang=js"
export * from "./game-month-rounds2.vue?vue&type=script&lang=js"
import style0 from "./game-month-rounds2.vue?vue&type=style&index=0&id=0be8d2ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be8d2ad",
  null
  
)

export default component.exports